(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const productRecommendationsSection = document.querySelector('.product-recommendations');

  if (productRecommendationsSection) {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendationsSection);

      const baseUrl = productRecommendationsSection.dataset.url;
      const headingComplementary = productRecommendationsSection.dataset.headingComplementary;
      const headingRelated = productRecommendationsSection.dataset.headingRelated;

      fetchRecommendations(baseUrl + '&intent=complementary')
        .then((html) => {
          if (html) {
            updateSection(html);
          } else {
            return fetchRecommendations(baseUrl + '&intent=related').then((html) => {
              if (html) {
                updateSection(html);
              } else {
                collapseSection();
              }
            });
          }
        })
        .catch((e) => {
          console.error(e);
          collapseSection();
        });
    };

    function fetchRecommendations(url) {
      return fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const div = document.createElement('div');
          div.innerHTML = text;
          const recommendations = div.querySelector('.product-recommendations');

          // Only treat the response as valid if it contains real product cards.
          // An empty intent still returns the skeleton markup (grid/snap wrappers,
          // non-empty container), which must NOT be mistaken for results —
          // otherwise the related-intent fallback never runs and the skeleton
          // stays forever on products without complementary recommendations.
          if (recommendations && recommendations.querySelector('.product-card')) {
            return recommendations;
          }
          return null;
        });
    }

    function updateSection(recommendationsEl) {
      const newHtml = recommendationsEl.innerHTML;
      productRecommendationsSection.style.opacity = '0';
      window.setTimeout(() => {
        productRecommendationsSection.innerHTML = newHtml;
        // Force reflow so the opacity transition replays.
        void productRecommendationsSection.offsetWidth;
        productRecommendationsSection.style.opacity = '1';
      }, 200);
    }

    function collapseSection() {
      productRecommendationsSection.style.opacity = '0';
      window.setTimeout(() => {
        productRecommendationsSection.remove();
      }, 250);
    }

    const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
    observer.observe(productRecommendationsSection);
  }

  } catch(e) { console.error(e); }
})();
})();
